'use strict';

var SystemStatusPanelConfig = function SystemStatusPanelConfig($stateProvider) {
  $stateProvider.state('app.system-status', {
    url: '/workflow/system-status',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER,DYNAMIC_AVAILABILITY,FARES_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/system-status-panel.html'),
        controller: 'SystemStatusPanelController'
      },
      'mainToolbar': {
        template: require('../templates/system-status-toolbar.html'),
        controller: 'SystemStatusToolbarController'
      }
    }
  });
};
SystemStatusPanelConfig.$inject = ['$stateProvider'];
module.exports = SystemStatusPanelConfig;